const {Buffer} = require('buffer');

module.exports = Buffer;
